export default __webpack_public_path__ + "static/media/warning-ai.699cf0d6.png";